export const unitsState = state => state.units;

export const getLoadingUnits = state => unitsState(state).loading;

export const getResponseUnits = state => unitsState(state).response;

export const getUnits = state => unitsState(state).units;
